module.exports = __webpack_public_path__ + "img/penilaian-btp-sd.4b4bcb75.jpeg";